import {defineStore} from 'pinia';
import {useSessionStore} from '~/modules/shared/composables/stores/SessionStore';
import {User} from '~/modules/shared/composables/types/User';
import {globalFetchOptions, toastError} from '~/modules/shared/composables/utils/Helpers';
import {PermissionEnum} from '~/modules/shared/composables/utils/Enums';
import {ApiResponseNoPagination} from '../types/Api';

interface ResponseContext {
  response: {
    status: number;
  };
}

export const useUserStore = defineStore(
  'user',
  () => {
    const u = localStorage.getItem('current-user');
    const currentUser = ref<User | ICoreUser | undefined | any>(u !== null ? JSON.parse(u) : undefined);
    const isAdminForLocation = ref(false);

    const isSysAdmin = ref(false);
    const isMiddlewareLoading = ref(true);

    const setMiddlewareLoading = (value: boolean) => {
      isMiddlewareLoading.value = value;
    };

    const config = useRuntimeConfig();

    const getCurrentUser = async () => {
      const u = localStorage.getItem('current-user');

      //if (u === undefined || u === null) {
      const resp = await $fetch<{ data: User }>(`${config.public.legacyApiBase}/legacy/users/me`, {
        ...globalFetchOptions(),
        method: 'get',
        onResponseError(context: ResponseContext): Promise<void> | void {
          if (context.response.status === 401) {
            const useSession = useSessionStore();
            useSession.timeout();
          } else {
            const errorMessage = `Error.  Please try again or contact support.`;
            toastError('Error', errorMessage);
          }
        },
      });
      localStorage.setItem('current-user', JSON.stringify(resp.data));
      currentUser.value = resp.data;
      //}

      return currentUser.value;
    };

    const getEdsUser = async () => {
      const u = localStorage.getItem('current-user');

      const resp = await $fetch<ApiResponseNoPagination<ICoreUser>>(`/core-user/me`, {
            method: 'get',
            ...globalFetchOptions(),
            onResponseError(context: ResponseContext): Promise<void> | void {
          if (context.response.status === 401) {
            const useSession = useSessionStore();
            useSession.timeout();
          } else {
            const errorMessage = `Error.  Please try again or contact support.`;
            toastError('Error', errorMessage);
          }
        },
          });
      localStorage.setItem('current-user', JSON.stringify(resp.data));
      currentUser.value = resp.data;
      //}

      return currentUser.value;
    };

    const clearUser = () => {
      currentUser.value = undefined;
      localStorage.removeItem('current-user');
      isAdminForLocation.value = false;
    };

    // Gets user's SA Help Permissions
    const getUserPermissionTypes = () => {
      const permissions = ref(currentUser.value?.sahelpPermissions);
      const permissionTypes: number[] = [];
      if (permissions.value) {
        for (const item of permissions.value) {
          permissionTypes.push(item.permissionId);
        }
        return permissionTypes;
      }
    };

    const canEditThq = () => {
      if (
        currentUser.value?.tsammPermission.includes(PermissionEnum.GodPermission)
      ) {
        return true;
      }
      return false;
    };

    const canManage = () => {
      if (
        currentUser.value?.tsammPermission.includes(PermissionEnum.CanManage) ||
        currentUser.value?.tsammPermission.includes(PermissionEnum.GodPermission)
      ) {
        return true;
      }
      return false;
    };

    const onlyCanView = () => {
      return false;
    };

    const serverErrorOpenModal = ref(false);

    return {
      currentUser,
      getCurrentUser,
      isAdminForLocation,
      isSysAdmin,
      clearUser,
      getUserPermissionTypes,
      isMiddlewareLoading,
      setMiddlewareLoading,
      canManage,
      onlyCanView,
      serverErrorOpenModal,
      canEditThq,
      getEdsUser,
    };
  },
  {
    persist: true,
  }
);
